import { Text } from '@lichtblick/photon/atoms/text/text';
import { ExclamationMarkTriangleXs } from '@lichtblick/photon/icons/symbols/exclamation-mark-triangle-xs';
import type { PropsWithChildren } from 'react';

import styles from './error-banner.module.scss';

export const ErrorBanner: React.FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.banner}>
    <ExclamationMarkTriangleXs />
    <Text bold size="s">
      {children}
    </Text>
  </div>
);
